import { apiClient } from '@/services/api';
import { API_ENDPOINTS } from '@/types/api';
import type { ApiResult } from '@/types/api';
import type { AppInfoResponse } from '../types';

export class AppInfoService {
  static async getAppInfo(): Promise<ApiResult<AppInfoResponse>> {
    return apiClient.get<AppInfoResponse, undefined>(API_ENDPOINTS.INFO);
  }
}
